import classNames from 'classnames';

type Props = {
    backgroundColor:
        'bg-vibrant-blue-10p' | 'bg-vibrant-blue-30p' | 'bg-vibrant-blue';
    size?: string;
    children?: React.ReactNode;
    class?: string;
    className?: string;
};
export function Circle({
    className,
    class: class_,
    backgroundColor,
    size = 'w-full',
    children,
}: Props) {
    return (
        <div
            className={classNames(
                'flex aspect-square items-center justify-center rounded-full',
                'border border-vibrant-blue',
                class_ ?? className,
                backgroundColor,
                size,
            )}
        >
            {children}
        </div>
    );
}
